import i18n from '../../../../i18n/config';

export const getUserId = (user: any): string => {
  return user.id || user.accountId || user.email || user.name || '';
};

export const getUserEmail = (user: any): string => {
  return user.email || user.emailAddress || '';
};

export const getUserName = (user: any): string => {
  return (
    user.name ||
    user.displayName ||
    user.username ||
    user.email ||
    i18n.t('integrations:fallback.unknownUser')
  );
};

export const getProjectId = (project: any): string => {
  return project.id || project.key || project.name || '';
};

export const getProjectName = (project: any): string => {
  return project.name || project.title || project.key || i18n.t('integrations:fallback.unknownProject');
};

export const isGithub = (integrationName: string): boolean => {
  return integrationName.toLowerCase() === 'github';
};
